import React from 'react';
import { Link } from 'react-router-dom';
import "./Vibration.css";
import { useTranslation } from 'react-i18next';

function Vibration() {
  const { t } = useTranslation();
  return (
    <div className='vibration-container'>
      <div className="vibration-content">

        <div className='vibration-header'>
          <h3>{t('nav_pruduct_vibration')}</h3>
        </div>
        <div className='pro-text-promotion'>
          <p>{t('vibration-p-one')}</p>
          <p>{t('vibration-p-two')}</p>
          <p>{t('vibration-p-three')}</p>
        </div>

        <div className='vibration-features'>
          <div className='vibration-features-header'>
            <h3>{t('sealing-norm-header-text')}</h3>
          </div>
          <p><strong>{t('sealing-norm-p-one')}</strong>{t('viration-norm-info-one')}</p>
          <p><strong>{t('sealing-norm-p-two')}</strong>{t('viration-norm-info-two')}</p>
          <p><strong>{t('sealing-norm-p-three')}</strong>{t('viration-norm-info-three')}</p>
          <p><strong>{t('sealing-norm-p-four')}</strong>{t('viration-norm-info-four')}</p>
          <p><strong>{t('sealing-norm-p-five')}</strong>{t('viration-norm-info-five')}</p>
        </div>



        <div className='info-contact'>
          <Link to="/contact" className='btn-contact'>{t('sealing-norm-button')}</Link>
        </div>

      </div>
    </div>
  )
}

export default Vibration